import { render, staticRenderFns } from "./screening.vue?vue&type=template&id=4e997edc&scoped=true&"
import script from "./screening.vue?vue&type=script&lang=js&"
export * from "./screening.vue?vue&type=script&lang=js&"
import style0 from "./screening.vue?vue&type=style&index=0&id=4e997edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e997edc",
  null
  
)

export default component.exports